<template>
	<div class="container paygate-form">
		<div class="row">
			<div class="col pl-sm-0">
				<h2 class="support-txt">Support the Solidarity Fund by donating with PayGate Plus.</h2>
			</div>
		</div>
		<div class="row input-fields">
			<div class="col-lg-4 col-sm-12 col-xs-12">
				<div class="input-group">
					<input type="text" v-model="emailAddress" class="form-control" placeholder="Email Address"
							:class="{ 'input-error': ($v.emailAddress.$invalid && $v.emailAddress.$dirty) || ($v.emailAddress.$invalid && !formValid) }"
							aria-label="emailAddress" aria-describedby="basic-addon1">
				</div>
			</div>
			<div class="col input-fields-spacer d-block d-xs-block d-lg-none"></div>
			<div class="col-lg-5 col-sm-12 col-xs-12 business-id">
				<div class="input-group">
					<input type="text" maxlength="15" v-model="businessID" class="form-control" placeholder="ID/Passport/Business Reg. Number for tax purpose"
							:class="{ 'input-error': ($v.businessID.$invalid && $v.businessID.$dirty) || ($v.businessID.$invalid && !formValid) }"
							aria-label="businessID" aria-describedby="basic-addon1">
				</div>
			</div>
			<div class="col input-fields-spacer d-block d-xs-block d-lg-none"></div>
			<div class="col-lg-3  col-sm-12 col-xs-12">
				<div class="input-group">
					<input type="text" v-money="money"
							:class="{ 'input-error': ($v.amount.$invalid && $v.amount.$dirty) || ($v.amount.$invalid && !formValid) }"
							v-model="amount" class="form-control" placeholder="Amount" aria-label="amount" aria-describedby="basic-addon1">
				</div>
			</div>
		</div>
		<div class="form-error row" id="errorContainer" >
			<div class="col text-center " v-if="!formValid">
				<span class="text-danger" id="errorMessage" v-model="errorMessage">{{ errorMessage }}</span>
			</div>
		</div>
		<div class="row donate-btn-row justify-content-center">
			<div class="col-lg-4 text-center">
				<button type="button" class="btn btn-block payButton" :disabled="isLoading" v-on:click="sendPaymentDetails" v-bind:style="{ background : buttonColor }">
					DONATE
				</button>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col paymethods-block text-center">
                <img src="../assets/SVG/Visa.svg" class="paymethods icon-visa img-responsive">
                <img src="../assets/SVG/MasterCard.svg" class="paymethods h36 icon-mastercard img-responsive">
                <img src="../assets/SVG/SiD.svg" class="paymethods h36 icon-sid img-responsive">
                <img src="../assets/SVG/Zapper.svg" class="paymethods h32 icon-zapper img-responsive">
			</div>
		</div>
	</div>
</template>

<script>
	import {validationMixin} from 'vuelidate'
	import {TheMask} from 'vue-the-mask'
	import {validateEmail, validateAmount} from '../utility/validators'
	import {required, minLength, maxLength} from 'vuelidate/lib/validators'
	import { v4 as uuidv4 } from 'uuid';

	var crypto = require('crypto')
	var moment = require('moment')
	const axios = require('axios')

	export default {
		name:        'Initiate',
		//directives: { focus: focus },
		props:       {params: {type: Object}},
		components:  {TheMask},
		data:        function (){
			return {
				pageUrl:      '',
				buttonColor:  '#d23983',
				amount:       localStorage.getItem('AMOUNT'),
				businessID:   localStorage.getItem('REFERENCE'),
				emailAddress: localStorage.getItem('EMAIL'),
				moneyMask:    '##,###.##',
				isLoading:    false,
				formValid:    true,
				money:        {
					decimal:   '.',
					thousands: ',',
					prefix:    'R',
					suffix:    '',
					precision: 0,
					masked:    false /* doesn't work with directive */
				}
			}
		},
		mixins:      [validationMixin],
		validations: {
			amount:       {
				required,
				minLength: minLength(2),
				validateAmount
			},
			emailAddress: {
				required,
				validateEmail
			},
			businessID:   {

				minLength: minLength(6),
				maxLength: maxLength(15)
			}
		},
		methods:     {

			sendPaymentDetails: function (){
				this.buttonColor = 'rgb(204, 204, 204)'
				this.inputsValid()
				if(this.formValid){

					if(this.businessID === null || this.businessID.trim().length === 0){
						localStorage.setItem('REFERENCE','')
					} else {
						localStorage.setItem('REFERENCE',this.businessID)
					}

					let PAYGATE_ID = process.env.VUE_APP_PAYGATE_ID
					let REFERENCE =  uuidv4()
					let USER1 = this.businessID
					let AMOUNT = this.amount.replace(/[.,R]/g, '') * 100
					let CURRENCY = 'ZAR'
					let RETURN_URL = process.env.VUE_APP_BASE_URL + '?response=true&ref=' + REFERENCE
					let TRANSACTION_DATE = moment().format('Y-MM-DD H:mm:ss')
					let LOCALE = 'en-za'
					let COUNTRY = 'ZAF'
					let EMAIL = this.emailAddress.trim()

					let checksumValue = PAYGATE_ID + REFERENCE + AMOUNT + CURRENCY + RETURN_URL + TRANSACTION_DATE + LOCALE + COUNTRY + EMAIL + USER1 + process.env.VUE_APP_CODE

					var bodyFormData = new FormData()
					bodyFormData.set('PAYGATE_ID', PAYGATE_ID)
					bodyFormData.set('REFERENCE', REFERENCE)
					bodyFormData.set('AMOUNT', AMOUNT)
					bodyFormData.set('CURRENCY', CURRENCY)
					bodyFormData.set('RETURN_URL', RETURN_URL)
					bodyFormData.set('TRANSACTION_DATE', TRANSACTION_DATE)
					bodyFormData.set('LOCALE', LOCALE)
					bodyFormData.set('COUNTRY', COUNTRY)
					bodyFormData.set('EMAIL', EMAIL)
					bodyFormData.set('USER1', USER1)
					bodyFormData.set('CHECKSUM', crypto.createHash('md5').update(checksumValue).digest('hex'))

					axios({
						url:     process.env.VUE_APP_SECURE_DOMAIN + '/payweb3/initiate.trans',
						method:  'POST',
						headers: {'Content-Type': 'application/x-www-form-urlencoded'},
						data:    bodyFormData
					}).then((response) => {

						if(response.data === "CHECK_PWD" || response.data === "ERROR=DATA_CHK"){
							this.isLoading = false
							this.formValid = false
						} else {
							let postFormFields = response.data.split('&')

							const form = document.createElement('form')
							form.method = 'POST'
							form.action = process.env.VUE_APP_SECURE_DOMAIN + '/payweb3/process.trans'

							for (const key in postFormFields) {
								if(postFormFields.hasOwnProperty(key)){
									let field = postFormFields[key].split('=')
									const hiddenField = document.createElement('input')

                                  if (field[0] === 'PAY_REQUEST_ID'){
									  localStorage.setItem('PAY_REQUEST_ID', field[1])
									  localStorage.setItem('EMAIL', EMAIL)
									  localStorage.setItem('AMOUNT', AMOUNT/100)
                                  }

									hiddenField.type = 'hidden'
									hiddenField.name = field[0]
									hiddenField.value = field[1]

									form.appendChild(hiddenField)
								}
							}

							document.body.appendChild(form)
							form.submit()
						}
					})
						.catch((error) => {
							console.log(error)
							this.formValid = false;
						})

				} else {
					this.isLoading = false
				}

			},
			inputsValid(){
				this.errorMessage = ''
				this.formValid = true

				if(this.$v.amount.$invalid ){
					this.errorMessage = 'The minimum donation amount is R50.00'
					this.formValid = false;
				}

				if(this.$v.businessID.$invalid ){
					this.formValid = false;

					if (this.businessID.includes("/") && this.businessID.length > 4){
						this.errorMessage = 'Please enter a valid business registration number'
					} else {
						this.errorMessage = 'Please enter a valid South African ID, Passport or business registration number'
					}
				}

				if(this.$v.emailAddress.$invalid){
					this.errorMessage = 'Please enter a valid email address'
					this.formValid = false;
				}

				if(!this.formValid){
					this.buttonColor = '#d23983'
				}
			}

		},
		computed:    {}
	}
</script>

<style>
</style>
